exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white_tag{background-color:#fff;color:#213519;height:30px;font-size:32px;line-height:30px}.bt_orange svg{fill:#fff}.bt_orange:hover{border-color:#213519}.bt_orange{background-color:#ea4726;color:#fff;border-color:#ea4726}", ""]);

// exports
